import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from "@mui/material";
import { CloseButton, CloseIcon } from "../page/Profille/CustomDrawer";
import closeIconBlack from "../assets/images/chats/closeLogoBlack.svg";
import { useDispatch } from "react-redux";
import { handleCopyClick } from "../utils/copytoClipboard";
import { showToastMsg } from "../appStore/actions/global/action";
import { useTranslation } from "react-i18next";
import AlertPopUp from "./AlertPopUp";
import useAppSelectors from "../customHooks/useAppSelectors";
import { Stack } from "@mui/system";
import { getInviteUrl } from "../appStore/actions/subscriber/action";
import { InviteType } from "../utils/constant";

const InvitePopup = ({ closePopUp, isGroupInvite = false, groupData }) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData } = useAppSelectors();
  const [isPermissionModalOpen, setPermissionModal] = useState(false);
  const [internalInviteLink, setInternalInviteLink] = useState("");
  const [externalInviteLink, setExternalInviteLink] = useState("");

  const dispatch = useDispatch();

  const handleCopyClickCallback = (type) => {
    if (type === "error") {
      dispatch(showToastMsg(appContent?.KEY52));
    } else {
      dispatch(showToastMsg(appContent?.KEY53));
    }
    closePopUp();
  };

  const handleCopyInvite = (inviteLink, type) => {
    if (inviteLink) {
      handleCopyClick(inviteLink, handleCopyClickCallback);
    } else {
      dispatch(showToastMsg(appContent?.KEY52));
    }
  };

  const handleGetInviteLink = async (type) => {
    const grpId = isGroupInvite ? groupData?.id : 0;
    const res = await dispatch(getInviteUrl(type, grpId));
    const inviteMessage = res?.data?.inviteMessage;

    if (type === InviteType.internal) {
      setInternalInviteLink(inviteMessage);
    } else if (type === InviteType.external) {
      setExternalInviteLink(inviteMessage);
    }
  };

  const fetchInviteLinks = async () => {
    await handleGetInviteLink(InviteType.internal);
    await handleGetInviteLink(InviteType.external);
  };

  useEffect(() => {
    fetchInviteLinks();
  }, [currentUserData]);

  return (
    <>
      <AlertPopUp
        title={"Access Denied ."}
        bodyContent={appContent?.KEY168}
        open={isPermissionModalOpen}
        closeModal={() => setPermissionModal(false)}
      />
      <Box
        sx={{ zIndex: 1204 }}
        position="fixed"
        top={0}
        left={0}
        width="100%"
        height="100%"
        bgcolor="rgba(0, 0, 0, 0.7)"
      >
        <Box
          zIndex={10}
          position="absolute"
          bgcolor="#FFFFFF"
          width={"30rem"}
          height={"16.5rem"}
          padding={"1rem"}
          top="27%"
          left="38%"
          transform={`translate(-50%, -50%)`}
          boxShadow={`0px 3.4402036666870117px 3.4402036666870117px 0px rgba(0, 0, 0, 0.25)`}
          borderRadius={"0.12rem"}
        >
          <Box display={"flex"} gap={"0.6rem"}>
            <Box>
              <CloseButton onClick={closePopUp}>
                <CloseIcon src={closeIconBlack} alt="close" />
              </CloseButton>
            </Box>
            <Box>
              <Typography fontSize={"1rem"} variant="h6">
                Invite People in: {groupData?.name}
              </Typography>
            </Box>
          </Box>

          <Box width={"81.8%"} margin={"auto"}>
            <Box mt={"0.5rem"}>
              <Typography
                fontWeight={"400"}
                fontSize={"0.75rem"}
                variant="h6"
                color={"#183242"}
                textAlign={"start"}
              >
                {isGroupInvite
                  ? "Your invitee will join the group and your contacts. you can add them to other groups by clicking people icon in the respective groups."
                  : "Your invitee will join your contacts. You can add them to groups by clicking the people icon in the respective groups."}
              </Typography>
            </Box>

            <Stack direction="row" alignItems="flex-start" mt={4.5}>
              <Box>
                <Button
                  onClick={() => handleCopyInvite(internalInviteLink, InviteType?.internal)}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#ffffffffff",
                    padding: "5px 10px",
                    color: "#020202ff",
                    fontSize: "0.8rem",
                    minWidth: "unset",
                    border: "1px solid #020202ff",
                    minHeight: "unset",
                    borderRadius: "0.15rem",
                    ml: "4.3rem",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#ffffffff",
                      color: "#000000ff",
                    },
                  }}
                  disabled={!internalInviteLink && !externalInviteLink}
                >
                  {appContent?.KEY309}
                </Button>
                <Typography
                  mt={"0.5rem"}
                  display="block"
                  variant="caption"
                  fontSize={"0.75rem"}
                  textAlign="left"
                  ml={"-1.9rem"}
                  sx={{ whiteSpace: "nowrap" }}
                >
                  {appContent?.KEY18}
                </Typography>
              </Box>

              <Box>
                <Button
                   onClick={() => handleCopyInvite(externalInviteLink, InviteType.external)}
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#ffffffffff",
                    padding: "5px 10px",
                    color: "#020202ff",
                    fontSize: "0.8rem",
                    minWidth: "unset",
                    border: "1px solid #020202ff",
                    minHeight: "unset",
                    borderRadius: "0.15rem",
                    ml: "1rem",
                    boxShadow: "none",
                    "&:hover": {
                      backgroundColor: "#ffffffff",
                      color: "#000000ff",
                    },
                  }}
                  disabled={!externalInviteLink && !internalInviteLink}
                >
                  {appContent?.KEY310}
                </Button>
                <Typography
                  mt={"0.5rem"}
                  display="block"
                  variant="caption"
                  fontSize={"0.75rem"}
                  textAlign="left"
                  ml={"1.2rem"}
                  // sx={{ whiteSpace: "nowrap" }}
                >
                  {appContent?.KEY17}
                </Typography>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default InvitePopup;
